import { API_KEY, API_URL, API_URL_WITHOUT_USER } from "../../Utils/API";
import {
  getDispatch,
  getSnackbarSuccess,
  isLoadingAction,
} from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import ROUTES from "../../Utils/routesConstants";
import { REGISTER_MOBILE_NUMBER } from "../../Utils/types";

export const clearRegisterMobileNumberAction = () => (dispatch) => {
  getDispatch(REGISTER_MOBILE_NUMBER, "", dispatch);
};

export const generateOtpAction = (mobileNumber, navigate) => (dispatch) => {
  const url = `${API_URL}/GetOTPForProviderMobileNo?MobileNumber=${mobileNumber}`;
  isLoadingAction(true, dispatch);
  return HttpUtil.makeGET(
    url,
    {},
    {
      ApiKey: API_KEY,
    }
  ).then((res) => {
    if (res?.data?.status === true) {
      isLoadingAction(false, dispatch);
      getDispatch(REGISTER_MOBILE_NUMBER, mobileNumber, dispatch);
      getSnackbarSuccess("success", res?.data?.message, dispatch);
      navigate(ROUTES.VALIDATE_OTP);
    } else {
      isLoadingAction(false, dispatch);
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const validateOtpAction = (data, navigate) => (dispatch) => {
  const url = `${API_URL}/VerifyProviderMobileNo`;
  return HttpUtil.makePOST(url, data, {
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      const temp1 = res?.data?.results?.menus?.filter(
        (ele) => ele?.menuItem?.isSelected === true
      )?.[0]?.menuItem?.url;
      localStorage.setItem(
        "tokenProviderPortal",
        `Bearer ${res?.data?.results?.token}`
      );
      localStorage.setItem(
        "menusProviderPortal",
        JSON.stringify(res?.data?.results?.menus)
      );
      localStorage.setItem(
        "providerIdProviderPortal",
        res?.data?.results?.providerId
      );
      localStorage.setItem(
        "chainIdProviderPortal",
        res?.data?.results?.chainId
      );
      localStorage.setItem("ProviderPortalRole", res?.data?.results?.role);
      localStorage.setItem("showDefaultMenuProviderPortal", temp1);
      clearRegisterMobileNumberAction();
      navigate(temp1);
    } else {
      getSnackbarSuccess("error", res?.data?.message, dispatch);
    }
  });
};

export const loginNetworkPortalAction = (e, navigate) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/Network/Login`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      const temp1 = res?.data?.results?.menus?.filter( (ele) => ele?.menuItem?.isSelected === true)?.[0]?.menuItem?.url;
      const temp2 = res?.data?.results?.menus?.filter( (ele) => ele?.menuItem?.isSelected === true)?.[0]?.menuItem;
      const temp3 = res?.data?.results?.menus?.filter((ele)=>ele?.menuItem?.title === "Provider Payout")
        localStorage.setItem("validateProviderPayout", JSON.stringify(temp3));
      
      localStorage.setItem(
        "tokenProviderPortal",
        `Bearer ${res?.data?.results?.token}`
      );
      localStorage.setItem("NetworkMenuId", JSON.stringify(temp2));
      localStorage.setItem(
        "menusProviderPortal",
        JSON.stringify(res?.data?.results?.menus)
      );
      localStorage.setItem("networkUserTypeId", res?.data?.results?.userTypeId);
      localStorage.setItem("networkUserId", res?.data?.results?.userId);
      localStorage.setItem("userName", res?.data?.results?.fullName);
      localStorage.setItem("roleName", res?.data?.results?.roleName);
      localStorage.setItem("showDefaultMenuProviderPortal", temp1);
      localStorage.setItem("userRoleCode",res?.data?.results?.userRoleCode)
      if (res?.data?.results?.menus?.length) {
        navigate(temp1);
        
      } else {
        navigate(ROUTES.UNATHORIZED);
      }
    } else {
      getSnackbarSuccess("warning", res?.data?.message, dispatch);
    }
  });
};
export const loginServiceProviderAction = (e, navigate) => (dispatch) => {
  const url = `${API_URL}/LoginwithEmailPassword`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
  }).then((res) => {
    if (res?.data?.status === true) {
      const temp1 = res?.data?.results?.menus?.filter(
        (ele) => ele?.menuItem?.isSelected === true
      )?.[0]?.menuItem?.url;
      localStorage.setItem(
        "tokenProviderPortal",
        `Bearer ${res?.data?.results?.token}`
      );
      localStorage.setItem(
        "menusProviderPortal",
        JSON.stringify(res?.data?.results?.menus)
      );
      localStorage.setItem(
        "providerIdProviderPortal",
        res?.data?.results?.providerId
      );
      localStorage.setItem(
        "chainIdProviderPortal",
        res?.data?.results?.chainId
      );
      localStorage.setItem("ProviderPortalRole", res?.data?.results?.role);
      localStorage.setItem("showDefaultMenuProviderPortal", temp1);
      clearRegisterMobileNumberAction();
      navigate(temp1);
    } else {
      getSnackbarSuccess("warning", res?.data?.message, dispatch);
    }
  });
};

export const loginWithRedirectionTokenAction =
  (redirectionToken, navigate) => (dispatch) => {
    const url = `${API_URL_WITHOUT_USER}/User/LoginwithRedirectionToken/${redirectionToken}`;
    return HttpUtil.makePOST(
      url,
      {},
      {
        ApiKey: API_KEY,
      }
    ).then((res) => {
      if (res?.data?.status === true) {
        const temp1 = res?.data?.results?.menus?.filter(
          (ele) => ele?.menuItem?.isSelected === true
        )?.[0]?.menuItem?.url;
        localStorage.setItem(
          "tokenProviderPortal",
          `Bearer ${res?.data?.results?.token}`
        );
        localStorage.setItem(
          "menusProviderPortal",
          JSON.stringify(res?.data?.results?.menus)
        );
        localStorage.setItem(
          "providerIdProviderPortal",
          res?.data?.results?.providerId
        );
        localStorage.setItem(
          "chainIdProviderPortal",
          res?.data?.results?.chainId
        );
        localStorage.setItem("ProviderPortalRole", res?.data?.results?.role);
        localStorage.setItem("showDefaultMenuProviderPortal", temp1);
        clearRegisterMobileNumberAction();
        navigate(temp1);
      } else {
        getSnackbarSuccess("warning", res?.data?.message, dispatch);
      }
    });
  };
